module.exports = __webpack_public_path__ + "static/media/mountain-city-solid.775c526c.svg";